module.exports = __webpack_public_path__ + "media/svg/tf-aa934969.svg";